module.exports = __webpack_public_path__ + "img/yellow-ladybird.4b821618.svg";